// extracted by mini-css-extract-plugin
export default {"container":"SocialButtons_container__1Olxm","container1":"SocialButtons_container1__NBUbg","button":"SocialButtons_button__CziU9","icon":"SocialButtons_icon__2yo7g"};